<template>
  <div id="dialog">
    <!-- confirmation modal -->
    <v-dialog v-model="confirmation.dialog" persistent max-width="360px">
      <v-card>
        <v-card-title class="headline lighten-2">{{ confirmation.title }}</v-card-title>
        <v-card-text class="mt-3">
          <p>{{ confirmation.message }}</p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn text color="warning" @click="hideDialog">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" :loading="loading" @click="buy(confirmation.price)">Buy</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex"
export default {
  data: () => {
    return {
      loading: false
    }
  },
  computed: mapState(["confirmation", "user"]),
  created(){
    if (this.user && this.user.ReferredById != "null" && !this.user.ReferredFulfilled){
      this.$store.dispatch("addNotification", {
        type: "success",
        message: "Heya, We just wanted to let you know that your referral will be applied during the first purchase.",
      });
    }
  },
  methods: {
    ...mapActions(["hideDialog"]),
    buy(amount) {
      this.loading = true;
      this.$axios
        .post(this.$cfg.ACCOUNTS_API_URL + "s/payment-intents", {
          amount: amount,
        })
        .then((response) => {
          return this.$axios.post(this.$cfg.API_URL + "store/purchase-tokens", {
            Id: response.data.id,
            ReferralById: this.user.ReferredById,
          });
        })
        .then(() => {
          this.$store.dispatch("FetchUser");
          this.$store.dispatch("addNotification", {
            type: "success",
            message: "Nice! Your balance was updated.",
          });
          this.hideDialog()
          this.$store.dispatch("hideBuyTokensDialog");
          if (this.$route.query.continue) {
            this.$router.push({ path: this.$route.query.continue })
          }
        })
        .catch((error) => {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            this.$store.dispatch("addNotification", {
              type: "error",
              message: error.response.data.errors,
            });
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            this.$store.dispatch("addNotification", {
              type: "error",
              message: "Network error",
            });
          } else {
            // Something happened in setting up the request that triggered an Error
            this.$store.dispatch("addNotification", {
              type: "error",
              message:
                "We're really sorry our systems seems to be unhealty now. Please try again later or contact us.",
            });
          }
        })
        .then(() => {
          this.loading = false;
        });
    }
  }
}
</script>